module.exports = __webpack_public_path__ + "static/fabric-stack-shrink-ccdb5391c60ddc3bc0d70aae91715118.gif";